<template>
    <b-modal id="notification-modal" size="xl" centered hide-header hide-footer body-class="p-0">
        <div class="modal-header bg-primary d-flex justify-content-between">
            <div class="device-modal d-flex flex-row align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
                    <path
                        fill="#ffffff"
                        d="M11 13h2V8h-2zm1 3q.425 0 .713-.288T13 15t-.288-.712T12 14t-.712.288T11 15t.288.713T12 16m-8 3v-2h2v-7q0-2.075 1.25-3.687T10.5 4.2v-.7q0-.625.438-1.062T12 2t1.063.438T13.5 3.5v.7q2 .5 3.25 2.113T18 10v7h2v2zm8 3q-.825 0-1.412-.587T10 20h4q0 .825-.587 1.413T12 22m-4-5h8v-7q0-1.65-1.175-2.825T12 6T9.175 7.175T8 10z"
                    />
                </svg>
                <p class="text-light m-0 fs-4 ms-1">Notificaciones</p>
            </div>
            <div class="close-modal d-flex" @click="close">
                <img src="@/assets/img/close.svg" />
            </div>
        </div>
        <div class="d-flex flex-column p-3">
            <ul class="list-group">
                <li
                    class="list-group-item d-flex flex-row justify-content-between align-items-center"
                    v-for="notification in notifications"
                    :key="notification.id"
                >
                    <div class="d-flex flex-row align-items-center">
                        <img :src="require('@/assets/img/notifications/' + mapImg(notification.type) + '.png')" />
                        <p class="m-0 ms-2">{{ notification.attributes?.name || 'Alertas' }}</p>
                    </div>
                    <div class="d-flex flex-row" style="gap: 5px">
                        <div class="edit d-flex" @click="openEditNotification(notification.id)">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="icon icon-tabler icon-tabler-edit"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                stroke-width="0.5"
                                stroke="#2c3e50"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                                <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                                <path d="M16 5l3 3" />
                            </svg>
                        </div>
                        <div
                            class="delete d-flex"
                            @click="deleteNotification(notification.attributes.name, notification.id)"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="icon icon-tabler icon-tabler-trash"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="#2c3e50"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M4 7l16 0" />
                                <path d="M10 11l0 6" />
                                <path d="M14 11l0 6" />
                                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                            </svg>
                        </div>
                    </div>
                </li>
            </ul>
            <b-button variant="primary" class="mt-3" @click="openCreateNotification">Crear Notificación</b-button>
        </div>
    </b-modal>
</template>

<script lang="ts">
import NotificationService from '@/api/services/notification.service'
import { NotificationImgType } from '@/models/enum-types/notification-img-type.enum'
import notificationsModule from '@/store/modules/notifications.module'
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class Notifications extends Vue {
    mapImg(type: string) {
        return Object(NotificationImgType)[type]
    }

    close() {
        this.$bvModal.hide('notification-modal')
    }

    show() {
        this.$bvModal.show('notification-modal')
    }

    get notifications() {
        return notificationsModule.notifications
    }

    async deleteNotification(notificationName: string, notificationId: number) {
        const result = await this.$bvModal.msgBoxConfirm(`Desea Eliminar la Notificación: ${notificationName}`, {
            title: 'Confirmar Acción',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'text-light',
            headerBgVariant: 'primary',
            okTitle: 'Aceptar',
            cancelTitle: 'Cancelar',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
        })
        if (result) {
            await NotificationService.deleteNotification(notificationId)
            const notifications = notificationsModule.notifications
            notificationsModule.setNotifications(
                notifications.filter((notification) => notification.id !== notificationId)
            )
        }
    }

    openCreateNotification() {
        notificationsModule.setModalMode('create')
        notificationsModule.setModalData({
            name: '',
            selected: 'alarm',
            devicesId: [],
            emailItems: ['',''],
        })
        this.$bvModal.show('notification-data-modal')
    }

    openEditNotification(notificationId: number) {
        const notification = this.notifications.find((notification) => notification.id === notificationId)
        if (!notification) return
        notificationsModule.setModalData({
            name: notification.attributes.name,
            selected: notification.type,
            devicesId: notification.attributes.devicesId,
            emailItems: notification.attributes.emails,
            id: notificationId,
        })
        notificationsModule.setModalMode('edit')
        this.$bvModal.show('notification-data-modal')
    }
}
</script>

<style lang="sass" scoped>
@import '@/assets/style/variables.sass'
@import '@/assets/style/modal-styles.sass'

.list-group
    overflow: auto !important
    max-height: 70vh !important
.list-group-item
    p
        line-height: 20px
    img
        height: 30px
.edit, .delete
    cursor: pointer
    transition: all 0.1s ease
    &:active
        transform: scale(.9)
.icon
    stroke: $secondary
    width: auto
    height: 25px
    stroke-width: 2px
</style>
